var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.segmentsLabel))]),_c('a-tooltip',{attrs:{"placement":"right","get-popup-container":_vm.getPopupContainer,"overlayStyle":{
      whiteSpace: 'normal',
      minWidth: '300px',
      maxWidth: 'none'
    }},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',[_vm._v("To work with segments, go to control panel:")]),_c('a',{staticClass:"d-block text-primary",attrs:{"href":_vm.segmentsLink,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.segmentsLink)+" ")])]},proxy:true}])},[_c('a-icon',{staticClass:"text-primary",attrs:{"type":"info-circle"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }